import Queue from '@sravni/utils/lib/queue';

export default new Queue({ debug: true });
